import Vue from 'vue'
import VueIcon from '@conch/svg-symbol-icon/VueIcon.js'

Vue.component('Icon', VueIcon)
